import React, { Component, useState, useEffect, useRef } from 'react';
import _, { filter } from "lodash";
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import { getDDMMYYYY, getDDMMYYYYHHMMSS, getHyphenDDMMMYYYYHHMM, getYYYYMMDD, getYYYYMMDDHHMMSS } from '../common/utils';
import $ from "jquery";
import Trucklocaction from './trucklocationnew';
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import moment from 'moment';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import TransportDashboard from './transportDashboard';
var redirectURL = require('../redirectURL');
var googleAnalytics = require("../common/googleanalytics");
const decipher = salt => {
    const textToChars = text => text.split('').map(c => c.charCodeAt(0));
    const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded => encoded.match(/.{1,2}/g)
        .map(hex => parseInt(hex, 16))
        .map(applySaltToChar)
        .map(charCode => String.fromCharCode(charCode))
        .join('');
}
var decode = decipher("V744c@XBTY!uHWA#v6Fe$GXmx%EXuN&ov(6fkW)x");
export default class ReturnLoadPercentage extends Component {
    constructor(props) {
        super(props);
        this.displayData = [];
        this.state = {
            pageTitle: "",
            eventGridAction: "gridAction",
            eventCounterAction: "counterAction",
            eventFormAction: "formAction",
            showform: 'show-m',
            loadshow: 'show-n',
            showrefresh: 'show-n',
            sliderTranslate: '',
            showdata: this.displayData,
            modules: AllModules,
            radius: '15',
            rlatitude: '',
            rlongitude: '',
            latitude: '',
            longitude: '',
            defaultradius: 0,
            coordinates: [],
            alert: null,
            show: false,
            basicTitle: '',
            basicType: "default",
            contentString: "testing",
            mwidth: "col-xl-12 col-lg-12",
            dept_code: '',
            defaultColDef: {
                sortable: false,
                filter: false,
                //editable: false,
                resizable: true,
                suppressMenu: true,
            },
            rowData: [],
            originalrowData: [],
            selectedTabLat: '',
            selectedTabLng: '',
            deftab: 'all',
            rowModelhighchartoptionsType: 'enterprise',
            rowGroupPanelShow: 'always',
            animateRows: true,
            debug: true,
            showToolPanel: false,
            rowSelection: "single",
            context: { componentParent: this },
            loadingCellRenderer: "customLoadingCellRenderer",
            loadingCellRendererParams: { loadingMessage: "One moment please..." },
            rowModelType: "serverSide",
            paginationPageSize: 50,
            cacheBlockSize: 50,
            maxBlocksInCache: 2,
            plant_code: '',
            showPlant: 'show-n',
            showAddr: 'show-n',
            request_type: '',
            view_type: '',
            tabplants: [],
            clickabletab: '',
            plantlist: [],
            stateFormData: "",
            sliderStateEmailsTranslate: "",
            overly: "show-n",
            showStateTrucksMsg: "show-n",
            states_list: [],
            selectedState: [],
            showStates: "show-n",
            showRadius: "show-m",
            usermanualmodal: false,
            plants: [],
            loginplant: "",
            showPreDefinedGeoFence: "show-n",
            geoPlantArr: [],
            plantsArr: [],
            dropDownValue: '',
            frameworkComponents: {
                trucklocaction: Trucklocaction
            },
            plant_codes: { label: "Gurgaon", value: "HHHG" },
            tpt_codes: { label: "ALL", value: "ALL" },
            plant_codes_optins: [{ label: "Gurgaon", value: "HHHG" }, { label: "Dharuhera", value: "HHHD" }, { label: "Haridwar", value: "HHHU" }, { label: "Neemrana", value: "HM4N" }, { label: "Halol", value: "HM5V" }, { label: "Chittoor", value: "HM6C" },],
            tpt_codes_optins: [{ label: "ALL", value: "ALL" },],
            plant_to_oem_in_range: [],
            today_prediction: [],
            today_trucks: [],
            tomorrow_prediction: [],
            tomorrow_trucks: [],
            oem_trucks: [],
            oem_trucks_tomorrow: [],
            plantgeofenceRadius: 50 * 1000,
            currentPage: 0,
            ITEMS_PER_PAGE: 16, // default or configurable
            selected_counter: 'today',
            sel_sub_counter: '',
            showAgGrid: false,
            selected_tpt_name: '',
            activeTab: 1,
            fromMonth: moment().subtract(4, 'months').format('MMM-YY'),
            toMonth: moment(new Date()).format("MMM-YY"),
            columnDefs: [],
            highChartsData: [],
            sliderTranslateGrid: '',
            selected_cell_data: {},
            selected_header: '',
            is_hide_for: '',
            repeated_geofence_combinations: [],
            detailed_grid_data: [],
            detailedGridData: [],
            show_detailed_grid: false,
            detailedGridTitle: 'Return Trips With Load',
            repeated_geo_columns: false,
        };
        this.onClickedOnCityWiseCount = this.onClickedOnCityWiseCount.bind(this);
    }
    /*Alert Popups*/
    closeAlert = () => {
        this.setState({
            show: false
        });
    }
    logPageView = () => {
        try {
            if (googleAnalytics.page.enableGA) {
                googleAnalytics.logPageView();
                let eventGridAction = googleAnalytics.page.actionType.gridAction + " - " + window.location.pathname;
                let eventCounterAction = googleAnalytics.page.actionType.counterAction + " - " + window.location.pathname;
                let eventFormAction = googleAnalytics.page.actionType.formAction + " - " + window.location.pathname;
                this.setState({ eventGridAction: eventGridAction, eventCounterAction: eventCounterAction, eventFormAction: eventFormAction });
            } else {
                console.log("GA disabled...");
            }
        } catch (error) {
            console.error("Error occured while logging to GA, error = ", error);
        }
    }
    componentDidMount() {
        var loguser = decode(localStorage.getItem("m"));
        var loginplant = "";
        try {
            var luser = JSON.parse(loguser);
            loginplant = luser.is_plant_code;
            this.setState({
                loginplant: loginplant,
            })
        }
        catch (e) {
        }
        var upath = this.props && this.props.match && this.props.match.path && this.props.match.path.split("/") ? this.props.match.path.split("/") : ''
        var deptcode = upath && upath[2] ? upath[2] : '';
        this.setState({
            dept_code: deptcode,
            overly: "show-m",
            loadshow: "show-m"
        });
        var encode = this.cipher("V744c@XBTY!uHWA#v6Fe$GXmx%EXuN&ov(6fkW)x");
        const p_1 = { dept_code: deptcode.toUpperCase() }
        redirectURL.post("/consignments/plants", p_1)
            .then((resp) => {
                var records = resp.data;
                var plants = [];
                if (records.length > 0) {
                    records.map((item) => {
                        if (loginplant != "" && loginplant != undefined) {
                            if (item.plant_code == loginplant) {
                                plants.push(item);
                            }
                        }
                        else {
                            plants.push(item);
                        }
                    })
                }
                let items = [{ value: "ALL", label: "ALL" }]
                if (plants.length > 0) {
                    plants.forEach(item => {
                        items.push({ value: item.plant_code, label: item.plant_name });
                    });
                }
                this.setState({
                    plantsArr: items,
                    plants: items
                });
            })
        redirectURL.post("/consignments/preDefinedGeoFencePlants").then(plantResp => {
            let geoPlantsList = plantResp.data
            let geoPlantArr = [{ value: "ALL", label: "ALL" }]
            geoPlantsList.map(e => {
                geoPlantArr.push({ value: e, label: e })
            })
            this.setState({
                geoPlantArr
            })
        })
        redirectURL.post("/consignments/getdistincttpt").then(tptResp => {
            let tptList = tptResp.data
            let tptCodeArr = [{ value: "ALL", label: "ALL" }, ...tptList]
            this.setState({
                tpt_codes_optins: tptCodeArr
            })
        })
        this.logPageView(); // Log page view to GA
        redirectURL.post("/vicinity/getDistinctStates").then((response) => {
            this.setState({
                states_list: response.data,
                // overly: "show-n",
                // loadshow: "show-n"
            });
        }).catch((e) => {
            console.log(e)
        })
        let isScrollDisabled = true
        // this.loadtrucksdata("load", isScrollDisabled)
        this.LoadData()
    }
    cipher = (salt) => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        try {
            return text => text.split('')
                .map(textToChars)
                .map(applySaltToChar)
                .map(byteHex)
                .join('');
        }
        // eslint-disable-next-line no-unreachable
        catch (e) { }
    }
    onClickHideAll() {
        this.setState({
            overly: "show-n",
            sliderTranslateGrid: '',
        })
    }
    onGridReady = params => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    };
    onGridReady2 = params => {
        this.gridApi2 = params.api;
        this.gridColumnApi2 = params.columnApi;
    };
    createColumns(rowData) {
        // Extract all unique dates from the data
        const monthOrder = {
            Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
            Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
        };
        const allDates = [...new Set(
            rowData.flatMap(row =>
                Object.keys(row).filter(key => key !== 'transporter' && key !== 'parameters')
            )
        )].sort((a, b) => {
            const [monthA, yearA] = a.split(' - ');
            const [monthB, yearB] = b.split(' - ');
            // Compare years first
            if (parseInt(yearA) !== parseInt(yearB)) {
                return parseInt(yearA) - parseInt(yearB);
            }
            // If years are equal, compare months
            return monthOrder[monthA] - monthOrder[monthB];
        });
        const columns = [
            {
                headerName: "TRANSPORTER",
                field: "transporter",
                width: 300,
                pinned: "left",
                editable: false,
                cellClass: (params) => params.data.transporter ? ["cellstylegridY", "pstBg"] : "",
                cellStyle: (params) => params.data.transporter ? { borderBottom: '1px solid #ccc' } : null,
                rowSpan: (params) => {
                    const index = params.node.rowIndex;
                    // Apply rowspan of 4 every 4th row (i.e., index % 4 === 0)
                    return index % 4 === 0 ? 4 : 1;
                },
                suppressMovable: true
            },
            {
                headerName: "PARAMETERS",
                field: "parameters",
                width: 250,
                pinned: "left",
                editable: false,
                suppressMovable: true
            }
        ];
        // Add dynamic date columns
        allDates.forEach(date => {
            columns.push({
                headerName: date,
                field: date,
                width: 120,
                suppressMovable: true,
                valueFormatter: params => params.value !== undefined ? params.value : '-'
            });
        });
        this.setState({ columnDefs: columns });
    }
    transformRowData(rowData, dataForHighcharts = false) {
        // First group by transporter
        const groupedData = {};
        rowData.forEach(item => {
            if (!groupedData[item.transporter]) {
                groupedData[item.transporter] = {
                    "Total Trucks": {},
                    "Plant": {},
                    "Empty Return Trucks (%)": {},
                    "Return Trucks with Load (%)": {},
                    "Avg Dead KMs for Return Trucks with Load": {}
                };
            }
            // Map each parameter to its date value
            groupedData[item.transporter]["Total Trucks"][item.date] = item.total_consignments;
            // groupedData[item.transporter]["Plant"][item.date] = item.plant;
            groupedData[item.transporter]["Empty Return Trucks (%)"][item.date] = item.other_oem_load_not_taken_percent;
            groupedData[item.transporter]["Return Trucks with Load (%)"][item.date] = item.other_oem_load_taken_percent;
            groupedData[item.transporter]["Avg Dead KMs for Return Trucks with Load"][item.date] = item.avg_dead_miles_km;
        });
        // Convert to ag-Grid row format
        const result = [];
        Object.keys(groupedData).forEach(transporter => {
            const parameters = {
                "Total Trucks": "Total Trucks",
                // "Plant": "Plant",
                "Empty Return Trucks (%)": "Empty Return Trucks (%)",
                "Return Trucks with Load (%)": "Return Trucks with Load (%)",
                "Avg Dead KMs for Return Trucks with Load": "Avg Dead KMs for Return Trucks with Load"
            };
            Object.keys(parameters).forEach(paramKey => {
                result.push({
                    transporter: paramKey === "Total Trucks" ? transporter : dataForHighcharts ? transporter : '',
                    parameters: parameters[paramKey],
                    ...groupedData[transporter][paramKey]
                });
            });
        });
        return result;
    }
    LoadData = async () => {
        try {
            this.setState({
                loadshow: "show-m",
                overly: 'show-m'
            })
            let { tpt_codes, plant_codes, fromMonth, toMonth } = this.state;
            // console.log('fromMonth', fromMonth)
            // console.log('toMonth', toMonth)
            let selected_tpt = tpt_codes.value && tpt_codes.value.toLowerCase() === "all"
                ? ""
                : tpt_codes.label.split('-')[1] || "";
            let selected_plant = plant_codes.value && plant_codes.value.toLowerCase() === "all"
                ? ""
                : plant_codes.value || "";
            const tptCode = tpt_codes.value && tpt_codes.value.toLowerCase() === "all"
                ? ""
                : tpt_codes.label.split('-')[0] || ""
            let payload = {
                plant_code: selected_plant,
                // transporter_name: selected_tpt.trim(),
            }
            if (selected_tpt.trim()) {
                payload.transporter_name = selected_tpt.trim()
            }
            // Convert "MMM-YY" to full date and get start of month
            const startDate = moment(fromMonth, 'MMM-YY').startOf('month').format('YYYY-MM-DD 00:00:00');

            // Convert "MMM-YY" to full date and get end of month
            const endDate = moment(toMonth, 'MMM-YY').endOf('month').format('YYYY-MM-DD HH:mm:ss');
            if (fromMonth && toMonth) {
                payload.from_date = startDate
                payload.to_date = endDate
            }
            redirectURL.post("dashboard/returnTripsLoadAnalysis", payload)
                .then(async (response) => {
                    try {
                        if (response.data !== undefined && response.data !== "") {
                            let respData = response.data
                            // const rowData = respData.oem_load_summary || [];                            
                            const rowData = respData.repeated_geofence_combinations || [];
                            // let expandedRowData = await this.transformRowData(rowData, true)
                            // let expandedDataForHighCharts = await this.transformRowData(rowData, true)
                            // await this.createColumns(expandedRowData);
                            let repeated_geofence_combinations = rowData.filter(item => item.other_oem_load == 1) || []
                            let raw_repeated_geofence_combinations = repeated_geofence_combinations
                            if (repeated_geofence_combinations && repeated_geofence_combinations.length > 0 && tptCode) {
                                repeated_geofence_combinations = repeated_geofence_combinations.filter(item => {
                                    return item.transporter_code.trim() == tptCode.trim()
                                })
                            }
                            let filteredData = rowData
                            if (tptCode) {
                                filteredData = filteredData.filter(item => item.transporter_code.trim() == tptCode.trim())
                            }
                            await this.setState({
                                rowData: filteredData,
                                highChartsData: filteredData,
                                repeated_geofence_combinations,
                                raw_repeated_geofence_combinations,
                                rawRowData: rowData,
                                other_oem_load: rowData,
                                detailedGridData: repeated_geofence_combinations,
                                is_hide_for: true,
                                repeated_geo_columns: true,
                                loadshow: "show-n",
                                overly: "show-n",
                            });
                        }
                    } catch (e) {
                        console.error("Error", e);
                        this.setState({
                            loadshow: "show-n",
                            overly: "show-n",
                        });
                    }
                });
        } catch (e) {
            console.log("Error ", e)
        }
    }
    handlerFromMonthChange = (selectedDate) => {
        try {
            let fromMonth = moment(selectedDate).format("MMM-YY");  // Ensure it's a moment object
            // If fromMonth is greater than toMonth, reset or show an error
            if (this.state.toMonth && moment(fromMonth).isAfter(moment(this.state.toMonth))) {
                console.log("From month cannot be greater than To month.");
                this.setState({
                    fromMonth: '', // Reset fromMonth to empty string or any fallback value,
                    show: true,
                    basicTitle: `From month can't be greater than TO month`,
                    basicType: 'danger'
                });
            } else {
                this.setState({
                    fromMonth
                });
            }
        } catch (e) {
            console.log('Error ', e);
        }
    };
    handlerToMonthChange = (selectedDate) => {
        try {
            let toMonth = moment(selectedDate).format("MMM-YY");  // Ensure it's a moment object
            // If toMonth is less than fromMonth, reset or show an error
            if (this.state.fromMonth && moment(toMonth).isBefore(moment(this.state.fromMonth))) {
                console.log("To month cannot be less than From month.");
                this.setState({
                    toMonth: '', // Reset toMonth to empty string or any fallback value
                    show: true,
                    basicTitle: `To month can't be less than From month`,
                    basicType: 'danger'
                });
            } else {
                this.setState({
                    toMonth
                });
            }
        } catch (e) {
            console.log('Error ', e);
        }
    };
    onCellClicked = (cell) => {
        try {
            // console.log(cell, 'cell');
            let date = cell.colDef.headerName;
            let valueData = cell.data[date]
            let { fromMonth, toMonth } = this.state
            const parsedDate = moment(date, 'MMM-YYYY', true); // strict parsing    
            if (!parsedDate.isValid()) {
                console.warn('Invalid date format:', date);
                return; // Don't call API
            }
            // const start_date = parsedDate.startOf('month').format('YYYY-MM-DD HH:mm:ss');
            const start_date = moment(fromMonth, 'MMM-YY').startOf('month').format('YYYY-MM-DD HH:mm:ss')
            const end_date = moment(toMonth, 'MMM-YY').endOf('month').format('YYYY-MM-DD HH:mm:ss')
            let transporter_name = cell.data.transporter;
            let { plant_codes } = this.state
            let selected_plant = plant_codes.value && plant_codes.value.toLowerCase() === "all"
                ? ""
                : plant_codes.value || "";
            let parameter = cell.data.parameters;
            const loadMap = {
                'Total Trucks': null,
                'Empty Return Trucks (%)': 0,
                'Return Trucks with Load (%)': 1,
                'Avg Dead KMs for Return Trucks with Load': null
            };
            let load = loadMap[parameter]
            // console.log(load, 'load')
            let payload2 = {
                plant_code: selected_plant,
                transporter_name: transporter_name,
                start_date,
                end_date,
            };
            if (load == null && parameter != 'Total Trucks' || !valueData || valueData == 0) {
                return ''
            } else if (load == 0 || load == 1) {
                payload2.load = load
            }
            let is_hide_for = parameter == 'Total Trucks' || parameter == 'Empty Return Trucks (%)'
            // console.log(payload2, 'payload2')
            redirectURL.post("dashboard/geofenceDataforReturnTrips", payload2).then(response => {
                try {
                    let { geofence_data = [] } = response.data;
                    if (geofence_data && geofence_data.length) {
                        geofence_data = JSON.parse(geofence_data);
                    }
                    geofence_data = Array.isArray(geofence_data) ? geofence_data : []
                    // console.log(geofence_data, 'geofence_data');
                    this.setState({
                        geofence_data,
                        sliderRowData: geofence_data,
                        selected_cell_data: cell.data,
                        selected_header: date,
                        is_hide_for: is_hide_for,
                        sliderTranslateGrid: 'slider-translate-50p',
                        overly: 'show-m',
                    });
                } catch (e) {
                    console.error("Error parsing geofence data:", e);
                    this.setState({
                        loadshow: 'show-n',
                        overly: 'show-n',
                    });
                }
            });
        } catch (e) {
            console.error("Error in onCellClicked:", e);
        }
    }
    loadtrucksdata = (type, isScrollDisabled = false) => {
        try {
            // this.setState({
            //     overly: 'show-m',
            //     loadshow: 'show-m',
            // })
            let { plant_codes, fromMonth, toMonth, tpt_codes, raw_repeated_geofence_combinations, rawRowData } = this.state
            let selected_tpt = tpt_codes.value && tpt_codes.value.toLowerCase() === "all"
                ? ""
                : tpt_codes.label.split('-')[0] || "";
            let selected_plant = plant_codes.value && plant_codes.value.toLowerCase() === "all"
                ? ""
                : plant_codes.value || "";

            fromMonth = moment(fromMonth, 'MMM-YY').startOf('month').format('YYYY-MM-DD HH:mm:ss')
            toMonth = moment(toMonth, 'MMM-YY').endOf('month').format('YYYY-MM-DD HH:mm:ss')
            let payload = {
                plant_code: selected_plant,
                // transporter_name: transporter_name,
                start_date: fromMonth,
                end_date: toMonth,
            }
            let title = "Total Trips"
            if (type) {
                payload.load = type == 'load' ? 1 : 0
                title = type == 'load' ? 'Return Trips With Load' : 'Empty Return Trips'
            }
            if (selected_tpt) {
                payload.transporter_code = selected_tpt.trim()
            }
            if (type && !isScrollDisabled) {
                document.getElementById("detailedGridView").scrollIntoView({ behavior: "smooth" });
            }
            // redirectURL.post("dashboard/geofenceDataforReturnTrips", payload).then(response => {
            try {
                // let { geofence_data = [] } = response.data;
                // if (geofence_data && geofence_data.length) {
                //     geofence_data = JSON.parse(geofence_data);
                // }
                // // console.log(geofence_data, 'geofence_data')
                // geofence_data = Array.isArray(geofence_data) ? geofence_data : []
                let filteredData = rawRowData
                if (type) {
                    let filterValue = type == 'load' ? 1 : 0
                    filteredData = filteredData.filter(item => item.other_oem_load == filterValue)
                }
                if (selected_tpt) {
                    filteredData = filteredData.filter(item => item.transporter_code.trim() == selected_tpt.trim())
                }
                this.setState({
                    detailedGridData: filteredData,
                    show_detailed_grid: true,
                    // overly: 'show-n',
                    // loadshow: 'show-n',
                    is_hide_for: type !== "load" || type == "load",
                    detailedGridTitle: title,
                    repeated_geo_columns: false || type == "load" ? true : false,
                });
                if (title == "Return Trips With Load") {
                    this.setState({
                        detailed_grid_data: filteredData
                    })
                }
            } catch (e) {
                console.error("Error parsing geofence data:", e);
                // this.setState({
                //     loadshow: 'show-n',
                //     overly: 'show-n',
                // });
            }
            // });
        } catch (e) {
            console.log("Erro", e)
            this.setState({
                overly: 'show-n',
                loadshow: 'show-n',
            })
        }
        // Your logic here...
    };
    onClickedOnReturnTripCity = (payload) => {
        try {
            // console.log(payload, 'Payload received');
            // Extract values from the payload
            const other_oem_geofence = payload.other_oem_geofence;
            const plant_name = payload.plant_name;
            const consignee_area = payload.consignee_area;
            const selected_city = payload.selected_city;
            const selected_plant = payload.selected_plant;
            // Get data from the component's state
            const plant_codes_optins = this.state.plant_codes_optins;
            const repeated_geofence_combinations = this.state.repeated_geofence_combinations;
            let { tpt_codes } = this.state
            let selected_tpt = tpt_codes.value && tpt_codes.value.toLowerCase() === "all"
                ? ""
                : tpt_codes.label.split('-')[0] || "";
            // Step 1: Find the plant code for the given plant name
            // let return_plant_code = null;
            // for (let i = 0; i < plant_codes_optins.length; i++) {
            //     const label = plant_codes_optins[i].label;
            //     if (
            //         label &&
            //         plant_name &&
            //         label.toLowerCase().trim() === plant_name.toLowerCase().trim()
            //     ) {
            //         return_plant_code = plant_codes_optins[i].value;
            //         break;
            //     }
            // }
            // Step 2: Filter the data based on conditions
            const filteredData = repeated_geofence_combinations.filter(function (item) {
                const itemGeofence = item.other_oem_geofence ? item.other_oem_geofence.toLowerCase().trim() : '';
                const itemPlantName = item.return_plant_name ? item.return_plant_name.toLowerCase().trim() : '';
                const itemCity = item.consignee_area ? item.consignee_area.toLowerCase().trim() : '';
                const tptCode = item.transporter_code ? item.transporter_code.toLowerCase().trim() : '';
                const matchGeofence = other_oem_geofence &&
                    itemGeofence === other_oem_geofence.toLowerCase().trim();

                const matchPlant = selected_plant
                    ? plant_name && itemPlantName === plant_name.toLowerCase().trim()
                    : true;

                const matchCity = selected_city
                    ? itemCity === selected_city.toLowerCase().trim()
                    : true;
                const matchTptCode = selected_tpt
                    ? tptCode === selected_tpt.toLowerCase().trim()
                    : true;

                return matchGeofence && matchPlant && matchCity && matchTptCode;
            });
            // Step 3: Set filtered data and update the UI
            let title = payload.defaultTitle + " - " + other_oem_geofence
            this.setState({
                detailedGridData: filteredData,
                show_detailed_grid: true,
                // overly: 'show-n',
                // loadshow: 'show-n',
                is_hide_for: true,
                detailedGridTitle: title || '',
                repeated_geo_columns: true,
            });

            // Step 4: Scroll to the detailed grid view
            document.getElementById("detailedGridView").scrollIntoView({ behavior: "smooth" });

        } catch (error) {
            console.log("Error in onClickedOnReturnTripCity:", error);
        }
    };
    onClickedOnCityWiseCount = (payload) => {
        try {
            // console.log(payload, 'Payload received');
            // Extract values safely, defaulting to empty strings
            var plant_name = (payload && payload.plant_name) ? payload.plant_name : '';
            var consignee_area = (payload && payload.consignee_area) ? payload.consignee_area : '';
            var consignee_city = (payload && payload.consignee_city) ? payload.consignee_city : '';
            var truck_type = (payload && payload.truck_type) ? payload.truck_type : '';
            var defaultTitle = (payload && payload.defaultTitle) ? payload.defaultTitle : '';
            var selected_area = (payload && payload.selected_area) ? payload.selected_area : '';
            var selected_city = (payload && payload.selected_city) ? payload.selected_city : '';
            var is_load = truck_type === 'load' ? 1 : 0;
            var selected_plant = plant_name;
            var is_hide_for = true;
            var repeated_geo_columns = truck_type === 'load';
            var rowData = Array.isArray(this.state.rowData) ? this.state.rowData : [];
            var filteredData = rowData.filter(function (item) {
                var itemPlantName = (item && item.return_plant_name) ? item.return_plant_name.toLowerCase().trim() : '';
                var itemArea = (item && item.consignee_area) ? item.consignee_area.toLowerCase().trim() : '';
                var itemCity = (item && item.consignee_city) ? item.consignee_city.toLowerCase().trim() : '';
                var itemLoad = (typeof item.other_oem_load === 'number') ? item.other_oem_load : -1;
                // Apply plant filter only if plant_name is provided (not empty)
                var matchPlant = selected_plant && selected_plant !== '' ? itemPlantName === selected_plant.toLowerCase().trim() : true;
                // Apply area filter only if selected_area is provided and not 'All'
                // If selected_area is not provided, try to use consignee_area from payload as filter
                var areaFilterValue = (selected_area && selected_area !== '') ? selected_area : consignee_area;
                var matchArea = areaFilterValue && areaFilterValue !== 'All' ? itemArea === areaFilterValue.toLowerCase().trim() : true;
                // Apply city filter only if selected_city is provided and not 'All'
                // If selected_city is not provided, try to use consignee_city from payload as filter
                var cityFilterValue = (selected_city && selected_city !== '') ? selected_city : consignee_city;
                var matchCity = cityFilterValue && cityFilterValue !== 'All' ? itemCity === cityFilterValue.toLowerCase().trim() : true;
                // Match truck type always
                var matchTruckType = itemLoad === is_load;
                return matchPlant && matchArea && matchCity && matchTruckType;
            });
            // Compose clicked name based on which filter is present
            var clickedName = consignee_area || consignee_city || selected_area || selected_city || '';
            var titleType = repeated_geo_columns ? "Load Trips" : "Empty Trips";
            var title = defaultTitle + " - " + clickedName + " (" + titleType + ")";
            this.setState({
                detailedGridData: filteredData,
                is_hide_for: is_hide_for,
                repeated_geo_columns: repeated_geo_columns,
                detailedGridTitle: title
            });
            var detailedView = document.getElementById("detailedGridView");
            if (detailedView) {
                detailedView.scrollIntoView({ behavior: "smooth" });
            }
        } catch (error) {
            console.error("Error in onClickedOnCityWiseCount:", error);
        }
    };
    // onClickedOnCityWiseCount = (payload) => {
    //     try {
    //         console.log(payload, 'Payload received');
    //         var other_oem_geofence = payload && payload.other_oem_geofence ? payload.other_oem_geofence : '';
    //         var plant_name = payload && payload.plant_name ? payload.plant_name : '';
    //         var consignee_area = payload && payload.consignee_area ? payload.consignee_area : '';
    //         var truck_type = payload && payload.truck_type ? payload.truck_type : '';
    //         var defaultTitle = payload && payload.defaultTitle ? payload.defaultTitle : '';
    //         var selected_city = payload && payload.selcted_city ? payload.selcted_city : '';
    //         var is_load = truck_type === 'load' ? 1 : 0;
    //         var selected_plant = plant_name;
    //         var is_hide_for = true;
    //         var repeated_geo_columns = truck_type === 'load';
    //         var rowData = Array.isArray(this.state.rowData || '') ? this.state.rowData : [];
    //         var filteredData = rowData.filter(function (item) {
    //             var itemPlantName = item && item.return_plant_name ? item.return_plant_name.toLowerCase().trim() : '';
    //             var itemCity = item && item.consignee_area ? item.consignee_area.toLowerCase().trim() : '';
    //             var itemCityName = item && item.consignee_city ? item.consignee_city.toLowerCase().trim() : '';
    //             var itemLoad = typeof item.other_oem_load === 'number' ? item.other_oem_load : -1;
    //             var matchPlant = selected_plant ? itemPlantName === selected_plant.toLowerCase().trim() : true;
    //             var matchCity = consignee_area ? itemCity === consignee_area.toLowerCase().trim() : true;
    //             var matchSelCity = selected_city ? itemCityName === selected_city.toLowerCase().trim() : true;
    //             var matchTruckType = itemLoad === is_load;
    //             return matchPlant && matchCity && matchTruckType && matchSelCity;
    //         });
    //         var titleType = repeated_geo_columns ? "Load Trips" : "Empty Trips";
    //         var title = defaultTitle + " - " + consignee_area + " (" + titleType + ") ";
    //         this.setState({
    //             detailedGridData: filteredData,
    //             is_hide_for: is_hide_for,
    //             repeated_geo_columns: repeated_geo_columns,
    //             detailedGridTitle: title
    //         });
    //         var detailedView = document.getElementById("detailedGridView");
    //         if (detailedView) {
    //             detailedView.scrollIntoView({ behavior: "smooth" });
    //         }
    //     } catch (error) {
    //         console.log("Error in onClickedOnCityWiseCount:", error);
    //     }
    // };
    filterData = () => {
        try {
            const { tpt_codes, rawRowData, raw_repeated_geofence_combinations } = this.state;
            let selected_tpt = "";
            if (tpt_codes && tpt_codes.value && tpt_codes.value.toLowerCase() !== "all") {
                const label = tpt_codes.label;
                if (label && typeof label === 'string') {
                    selected_tpt = label.split('-')[0].trim();
                }
            }
            // Helper function to filter by transporter_code
            const filterByTransporterCode = (data, code) => {
                return data.filter(item => {
                    return item && item.transporter_code && item.transporter_code.trim() === code;
                });
            };
            let filteredData = rawRowData;
            let repeated_geofence_combinations = raw_repeated_geofence_combinations;
            let detailedGridData = raw_repeated_geofence_combinations;
            if (selected_tpt) {
                filteredData = filterByTransporterCode(rawRowData, selected_tpt);
                repeated_geofence_combinations = filterByTransporterCode(raw_repeated_geofence_combinations, selected_tpt);
                detailedGridData = filterByTransporterCode(raw_repeated_geofence_combinations, selected_tpt);
            }
            this.setState({
                rowData: filteredData,
                highChartsData: filteredData,
                repeated_geofence_combinations,
                detailedGridData,
                is_hide_for: true,
                repeated_geo_columns: true,
                detailedGridTitle: 'Return Trips With Load',
                // loadshow: "show-n",
                // overly: "show-n",
            });

        } catch (e) {
            console.log(e);
        }
    };
    render() {
        let { selected_cell_data, selected_header, is_hide_for, sliderRowData, plant_codes_optins, repeated_geo_columns } = this.state
        let hideFor = is_hide_for ? true : false
        let repeatedCols = is_hide_for && !repeated_geo_columns || !is_hide_for
        let sliderGridColumns = [
            {
                headerName: "Truck No",
                field: "truck_no",
                width: 150,
                editable: false,
            },
            {
                headerName: "Invoice No",
                field: "invoice_no",
                width: 150,
                editable: false,
            },
            {
                headerName: "Dealer City",
                field: "dealer_city",
                width: 180,
                editable: false,
                hide: hideFor,
                suppressColumnsToolPanel: hideFor,
            },
            {
                headerName: "Dealer City",
                field: "consignee_city",
                width: 180,
                editable: false,
                hide: repeatedCols,
                suppressColumnsToolPanel: repeatedCols,
            },
            {
                headerName: "Dealer Area",
                field: "consignee_area",
                width: 180,
                editable: false,
                hide: !hideFor,
                suppressColumnsToolPanel: !hideFor,
            },
            {
                headerName: "Dealer city",
                field: "consignee_city",
                width: 180,
                editable: false,
                hide: !repeatedCols,
                suppressColumnsToolPanel: !repeatedCols,
            },
            {
                headerName: "Transporter Code",
                field: "transporter_code",
                width: 180,
                editable: false,
            },
            {
                headerName: "Transporter Name",
                field: "transporter_name",
                width: 180,
                editable: false,
            },
            {
                headerName: "Left Dealer",
                field: "return_trip_start_date",
                width: 180,
                editable: false,
            },
            {
                headerName: "Geofence Name",
                field: "geofence_name",
                width: 180,
                editable: false,
                hide: hideFor,
                suppressColumnsToolPanel: hideFor,
            },
            {
                headerName: "Geofence Name",
                field: "other_oem_geofence",
                width: 180,
                editable: false,
                hide: repeatedCols,
                suppressColumnsToolPanel: repeatedCols,
            },
            {
                headerName: "Other OEM Geofence In",
                field: "otheroem_geofence_in",
                width: 180,
                editable: false,
                hide: hideFor,
                suppressColumnsToolPanel: hideFor,
            },
            {
                headerName: "Other OEM Geofence In",
                field: "other_oem_gate_in",
                width: 180,
                editable: false,
                hide: repeatedCols,
                suppressColumnsToolPanel: repeatedCols,
            },
            {
                headerName: "Other OEM Geofence Out",
                field: "otheroem_geofence_out",
                width: 180,
                editable: false,
                hide: hideFor,
                suppressColumnsToolPanel: hideFor,
            },
            {
                headerName: "Other OEM Geofence Out",
                field: "other_oem_gate_out",
                width: 180,
                editable: false,
                hide: repeatedCols,
                suppressColumnsToolPanel: repeatedCols,
            },
            {
                headerName: "OEM Geofence Duration",
                field: "otheroem_geofence_duration_seconds",
                width: 220,
                editable: false,
                valueFormatter: params => {
                    try {
                        const seconds = params.value;
                        if (seconds == null) return '';
                        const hours = Math.floor(seconds / 3600);
                        const minutes = Math.floor((seconds % 3600) / 60);
                        const parts = [];
                        if (hours > 0) parts.push(`${hours} Hrs`);
                        // if (minutes > 0 || hours === 0) parts.push(`${minutes}m`);            
                        return parts.join(' ');
                    } catch (e) {
                        console.log('Error ', e)
                    }
                },
                hide: hideFor,
                suppressColumnsToolPanel: hideFor,
            },
            {
                headerName: "OEM Geofence Duration",
                field: "other_oem_duration",
                width: 220,
                editable: false,
                valueFormatter: params => {
                    try {
                        const seconds = params.value;
                        if (seconds == null) return '';
                        const hours = Math.floor(seconds / 3600);
                        const minutes = Math.floor((seconds % 3600) / 60);
                        const parts = [];
                        if (hours > 0) parts.push(`${hours} Hrs`);
                        // if (minutes > 0 || hours === 0) parts.push(`${minutes}m`);            
                        return parts.join(' ');
                    } catch (e) {
                        console.log("Error", e)
                    }
                },
                hide: repeatedCols,
                suppressColumnsToolPanel: repeatedCols,
            },
            {
                headerName: "Return Plant",
                field: "return_plant_code",
                width: 180,
                editable: false,
                hide: hideFor,
                suppressColumnsToolPanel: hideFor,
                valueGetter: function (params) {
                    try {
                        var return_plant_code = params.data && params.data.return_plant_code;
                        var plant_name = '';
                        if (plant_codes_optins && return_plant_code) {
                            for (var i = 0; i < plant_codes_optins.length; i++) {
                                var item = plant_codes_optins[i];
                                if (item.value === return_plant_code.trim()) {
                                    plant_name = item.label;
                                    break;
                                }
                            }
                        }
                        return plant_name || '';
                    } catch (e) {
                        console.log("Error in valueGetter", e);
                        return '';
                    }
                }
            },
            {
                headerName: "Return Plant",
                field: "return_plant_name",
                width: 180,
                editable: false,
                hide: repeatedCols,
                suppressColumnsToolPanel: repeatedCols,
            },
            {
                headerName: "Return To Plant",
                field: "return_trip_end_date",
                width: 180,
                editable: false,
            },
            {
                headerName: "Return Trip KM",
                field: "return_trip_dist_kms",
                width: 160,
                editable: false,
                valueFormatter: (params) => {
                    try {
                        const value = Number(params.value);
                        return !isNaN(value) ? `${value.toFixed(2)} km` : '';
                    } catch (e) {
                        console.log('valueFormatter error:', e);
                        return '';
                    }
                }
            }
        ];
        return (
            <div className="container-fluid">
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>
                {this.state.alert}
                <div className="row">
                    <div className="col-xl-12 col-lg-12">
                        <div className='row'>
                            <form className={"d-flex theme-form col-xl-12 col-lg-12 mb-2 mt-2"} >
                                <div className='col-xl-2 col-lg-2 form-group'>
                                    <label className="c-lbl" htmlFor='plant_code'>Select Plant</label>
                                    <Select
                                        closeMenuOnSelect={true}
                                        name="plant_code"
                                        isMulti={false}
                                        placeholder="ALL"
                                        value={this.state.plant_codes}
                                        onChange={(e) => {
                                            this.setState({
                                                plant_codes: e
                                            })
                                        }}
                                        className="rp-select"
                                        options={this.state.plant_codes_optins} />
                                </div>
                                <div className='col-2'>
                                    <label className="c-lbl" htmlFor='tpt_codes'>Select Transporter</label>
                                    <Select
                                        closeMenuOnSelect={true}
                                        name="tpt_codes"
                                        isMulti={false}
                                        placeholder="ALL"
                                        className="rp-select"
                                        value={this.state.tpt_codes}
                                        onChange={(e) => {
                                            this.setState({
                                                tpt_codes: e
                                            }, () => {
                                                this.filterData()
                                            })
                                        }}
                                        options={this.state.tpt_codes_optins} />
                                </div>
                                <div className="col-xl-2 col-lg-2 form-group">
                                    <label className="c-lbl" htmlFor="fromMonth">From Month</label>
                                    <Datetime
                                        timeFormat={false} // Disable time selection
                                        dateFormat="MMM-YY" // Set the date format to only show year and month
                                        closeOnSelect={true}
                                        inputProps={{
                                            placeholder: 'From Month',
                                            name: 'fromMonth',
                                            id: 'fromMonth',
                                            autoComplete: 'off',
                                            readOnly: true,
                                            value: this.state.fromMonth // Assuming you have a state variable for the from month
                                        }}
                                        viewMode="months" // Start the picker in month view
                                        onChange={this.handlerFromMonthChange} // Your handler function for the from month
                                        className='date-z-index'
                                    />
                                </div>
                                <div className="col-xl-2 col-lg-2 form-group">
                                    <label className="c-lbl" htmlFor="toMonth form-group">To Month</label>
                                    <Datetime
                                        timeFormat={false} // Disable time selection
                                        dateFormat="MMM-YY" // Set the date format to only show year and month
                                        closeOnSelect={true}
                                        inputProps={{
                                            placeholder: 'To Month',
                                            name: 'toMonth',
                                            id: 'toMonth',
                                            autoComplete: 'off',
                                            readOnly: true,
                                            value: this.state.toMonth // Assuming you have a state variable for the to month
                                        }}
                                        viewMode="months" // Start the picker in month view
                                        onChange={this.handlerToMonthChange} // Your handler function for the to month
                                        className='date-z-index'
                                    />
                                </div>
                                <div className='col-xl-3 col-lg-3 form-group' style={{ alignContent: 'end' }}>
                                    <label className="c-lbl" htmlFor='btn'>    </label>
                                    <button className='btn btn-success' type="button" onClick={() => {
                                        this.LoadData()
                                        this.loadtrucksdata("load", true)
                                    }}>Submit</button>
                                </div>
                            </form>
                        </div>
                        <div className="card-body row pt-0 pr-0">
                            <div id='gridMapContainer' className="row col-xl-12 col-lg-12">
                                <div className={"dataLoadpage " + (this.state.loadshow)}>
                                </div>
                                <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                                    <div class="loader-box">
                                        <div class="loader-box">
                                            <div class="rotate dashed colored">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div id="myGrid" style={{ height: "100vh", width: "100%" }} className="ag-theme-balham">
                                    <AgGridReact
                                        modules={this.state.modules}
                                        columnDefs={this.state.columnDefs}
                                        defaultColDef={this.state.defaultColDef}
                                        rowData={this.state.rowData}
                                        enableCharts={false}
                                        enableRangeSelection={false}
                                        autoGroupColumnDef={this.state.autoGroupColumnDef}
                                        onGridReady={this.onGridReady}
                                        onGridState={this.onGridState}
                                        statusBar={this.state.statusBar}
                                        sideBar={this.state.sideBar}
                                        paginationPageSize={this.state.paginationPageSize}
                                        pagination={false}
                                        context={{ componentParent: this }}
                                        gridOptions={{
                                            context: { componentParent: this },
                                            getRowStyle: function (params) {
                                                if (params.node.rowPinned) {
                                                    return { 'font-weight': 'bold', 'font-size': '16px' };
                                                }
                                            },
                                            suppressMenu: true,
                                            suppressRowTransform: true,
                                        }}
                                        floatingFilter={false}
                                        onCellClicked={this.onCellClicked}
                                        frameworkComponents={this.state.frameworkComponents}
                                    />
                                </div> */}
                                {/* Commenting the Highchart spline chart  */}
                                {/* <div style={{ width: '100%', marginTop: '28px' }}>
                                    <TransportDashboard data={this.state.highChartsData} />
                                </div> */}
                                <div style={{ width: '100%', marginTop: '28px' }}>
                                    <TransporterPerformanceChart data={this.state.rowData} loadtrucksdata={this.loadtrucksdata} />
                                </div>
                                <div style={{ width: '100%', marginTop: '28px' }}>
                                    <ConsigneeAreaStackedChart data={this.state.rowData} onClickedOnCityWiseCount={this.onClickedOnCityWiseCount} />
                                </div>
                                <div style={{ width: '100%', marginTop: '28px' }}>
                                    <ConsigneeAreaChart data={this.state.repeated_geofence_combinations} onClickedOnReturnTripCity={this.onClickedOnReturnTripCity} />
                                </div>
                            </div>
                        </div>
                        <div id="detailedGridView" className="card-body row pt-0 ">
                            <div className='mb-2' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                <h6 style={{ margin: 0 }}>{this.state.detailedGridTitle}</h6>
                                <button
                                    className="btn btn-secondary"
                                    style={{ borderRadius: '4px', padding: '6px 12px' }}
                                    onClick={this.loadtrucksdata.bind(this, '')}
                                >
                                    Show All Data
                                </button>
                            </div>
                            <div id="myGrid" style={{ height: "500px", width: "100%" }} className="ag-theme-balham">
                                <AgGridReact
                                    modules={this.state.modules}
                                    columnDefs={sliderGridColumns}
                                    defaultColDef={{
                                        sortable: true,
                                        filter: true,
                                        resizable: true,
                                    }}
                                    rowData={this.state.detailedGridData}
                                    enableCharts={false}
                                    enableRangeSelection={false}
                                    autoGroupColumnDef={this.state.autoGroupColumnDef}
                                    onGridReady={this.onGridReady}
                                    onGridState={this.onGridState}
                                    statusBar={this.state.statusBar}
                                    sideBar={this.state.sideBar}
                                    paginationPageSize={this.state.paginationPageSize}
                                    pagination={true}
                                    context={{ componentParent: this }} // ✅ this is key!
                                    // enableRangeSelection={false}
                                    floatingFilter={false}
                                    onCellClicked={this.popmarker}
                                    frameworkComponents={this.state.frameworkComponents}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"slide-r " + (this.state.sliderTranslateGrid)} style={{ overflow: "auto" }}>
                    <div className="slide-r-title">
                        <h4>
                            {`${selected_cell_data.transporter} - ${selected_cell_data.parameters} ( ${selected_header} )`}
                            <span className="float-right closebtn" onClick={this.onClickHideAll.bind(this)} >X</span>
                        </h4>
                    </div>
                    <div className="slide-r-body" style={{ position: "relative" }}>
                        <div className="row col-xl-12 col-lg-12 ml-0p n-p-0"></div>
                        <div className={"row"} style={{ padding: '5px 0px', width: '100%', overflow: 'hidden', zIndex: '9999', height: "100em", margin: '24px' }} >
                            <div id="myGrid" style={{ height: "500px", width: "95%" }} className="ag-theme-balham">
                                <AgGridReact
                                    modules={this.state.modules}
                                    columnDefs={sliderGridColumns}
                                    defaultColDef={{
                                        sortable: true,
                                        filter: true,
                                        resizable: true
                                    }}
                                    rowData={this.state.sliderRowData}
                                    enableCharts={false}
                                    enableRangeSelection={false}
                                    autoGroupColumnDef={this.state.autoGroupColumnDef}
                                    onGridReady={this.onGridReady}
                                    onGridState={this.onGridState}
                                    statusBar={this.state.statusBar}
                                    sideBar={this.state.sideBar}
                                    paginationPageSize={this.state.paginationPageSize}
                                    pagination={true}
                                    context={{ componentParent: this }} // ✅ this is key!
                                    // enableRangeSelection={false}
                                    floatingFilter={false}
                                    onCellClicked={this.popmarker}
                                    frameworkComponents={this.state.frameworkComponents}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"slide-r " + (this.state.sliderTranslate)} >
                    <div className="slide-r-body" style={{ position: "relative" }}>
                        <div className={"dataLoadpage " + (this.state.loadshow)}>
                        </div>
                        <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                            <div class="loader-box">
                                <div class="loader-box">
                                    <div class="rotate dashed colored">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-12 col-lg-12">
                            {this.displayData}
                        </div>
                    </div>
                </div>
                <div className={"overlay-part " + (this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
            </div>
        );
    }
}

const TransporterPerformanceChart = ({ data, loadtrucksdata }) => {
    const getAggregatedData = () => {
        let totalTrucks = 0;
        let emptyReturnTrucks = 0;
        let returnTrucksWithLoad = 0;
        // Loop over each truck record
        data.forEach(item => {
            const hasReturnTrip = item.return_trip_start_date && item.return_trip_end_date;
            if (hasReturnTrip) {
                totalTrucks += 1;
                if (item.other_oem_load === 1) {
                    returnTrucksWithLoad += 1;
                } else {
                    emptyReturnTrucks += 1;
                }
            }
        });
        return {
            emptyReturnCount: emptyReturnTrucks,
            withLoadCount: returnTrucksWithLoad,
            totalTrucks
        };
    };
    const aggregatedData = getAggregatedData();
    const chartOptions = {
        chart: {
            type: 'pie',
            height: 400
        },
        title: {
            text: ''
        },
        tooltip: {
            useHTML: true,
            formatter: function () {
                const count = Math.round(this.point.y);
                const percentage = this.point.percentage.toFixed(1);
                return `
                    <div>
                        <strong>${this.point.name}</strong><br />
                        ${percentage}%<br />
                        <small>Count: ${count} of ${aggregatedData.totalTrucks} trips</small>
                    </div>
                `;
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                    style: {
                        color: 'black',
                        fontSize: '12px'
                    }
                },
                point: {
                    events: {
                        click: function () {
                            if (this.name === 'Return Trips with Load') {
                                loadtrucksdataforgrid('load');
                            } else if (this.name === 'Empty Return Trips') {
                                loadtrucksdataforgrid('noload');
                            }
                        }
                    }
                }
            }
        },
        series: [
            {
                name: 'Truck Returns',
                colorByPoint: true,
                data: [
                    {
                        name: 'Empty Return Trips',
                        y: aggregatedData.emptyReturnCount,
                        color: '#f28c8c' // Light red
                    },
                    {
                        name: 'Return Trips with Load',
                        y: aggregatedData.withLoadCount,
                        color: '#90ed7d'
                    }
                ]
            }
        ],
        legend: {
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal'
        }
    };
    const loadtrucksdataforgrid = (type) => {
        try {
            loadtrucksdata(type)
        } catch (e) {
            console.log("Erro", e)
        }
        // Your logic here...
    };
    return (
        <div className="transporter-dashboard" style={{ padding: '20px' }}>
            <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                <div style={{ fontSize: '1.2em', fontWeight: 'bold' }}>
                    Total Return Trips: {aggregatedData.totalTrucks}
                </div>
            </div>
            <HighchartsReact
                highcharts={Highcharts}
                options={chartOptions}
            />
        </div>
    );
};
const ConsigneeAreaChart = ({ data, onClickedOnReturnTripCity }) => {
    const allOption = { value: 'All', label: 'All' };
    const [selectedCity, setSelectedCity] = useState(allOption);
    const [selectedPlant, setSelectedPlant] = useState(allOption);
    const uniqueCities = [...new Set(data.map(d => d.consignee_area).filter(Boolean))];
    const uniquePlants = [...new Set(data.map(d => d.return_plant_name).filter(Boolean))];
    const cityOptions = [allOption, ...uniqueCities.map(city => ({ value: city, label: city }))];
    const plantOptions = [allOption, ...uniquePlants.map(plant => ({ value: plant, label: plant }))];
    const filteredData = data.filter(item => {
        const cityMatch = (selectedCity && (selectedCity.value === 'All' || item.consignee_area === selectedCity.value));
        const plantMatch = (selectedPlant && (selectedPlant.value === 'All' || item.return_plant_name === selectedPlant.value));
        return cityMatch && plantMatch;
    });
    const processData = () => {
        if (!filteredData || filteredData.length === 0) return [];
        const geoMap = {};
        for (let i = 0; i < filteredData.length; i++) {
            const item = filteredData[i];
            const geo = item && item.other_oem_geofence ? item.other_oem_geofence.trim() : null;
            if (!geo) continue;
            if (!geoMap[geo]) {
                geoMap[geo] = {
                    name: geo,
                    count: 0,
                    other_oem_geofence: geo,
                    plant_name: item.return_plant_name || ''
                };
            }
            geoMap[geo].count += 1;
        }
        const result = Object.values(geoMap);
        result.sort(function (a, b) {
            if (b.count === a.count) {
                return a.name.localeCompare(b.name); // Secondary sort by geofence name
            }
            return b.count - a.count; // Primary sort by count descending
        });
        return result;
    };
    const chartData = processData();
    const chartOptions = {
        chart: { type: 'column', height: 500 },
        title: { text: 'Other OEM Geofence Wise Count', align: 'left' },
        xAxis: {
            type: 'category',
            title: { text: 'Other OEM Geofences' },
            labels: {
                rotation: -45,
                style: { fontSize: '12px' }
            }
        },
        yAxis: {
            title: { text: 'Number of Trips' },
            min: 0
        },
        legend: { enabled: false },
        tooltip: {
            headerFormat: '<span style="font-size:12px"><b>{point.key}</b></span><table>',
            pointFormat: `
    <tr><td style="padding:0"><b>Trips:</b></td>
        <td style="padding:0;text-align:right"><b>{point.y}</b></td>
    </tr>
    <tr><td style="padding:0"><b>Other OEM Geofence:</b></td>
        <td style="padding:0;text-align:right">{point.other_oem_geofence}</td>
    </tr>
    <tr><td style="padding:0"><b>Plant Name:</b></td>
        <td style="padding:0;text-align:right">{point.plant_name}</td>
    </tr>`,

            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            column: {
                borderRadius: 5,
                borderWidth: 0,
                colorByPoint: true,
                colors: [
                    '#7cb5ec', '#434348', '#90ed7d', '#f7a35c', '#8085e9',
                    '#f15c80', '#e4d354', '#2b908f', '#f45b5b', '#91e8e1'
                ],
                dataLabels: {
                    enabled: true,
                    format: '{point.y}',
                    rotation: 0,
                    color: '#000000',
                    align: 'center',
                    style: { fontSize: '12px', textOutline: 'none' }
                },
                point: {
                    events: {
                        click: function () {
                            handleCellClick(this);
                        }
                    }
                }
            }
        },
        series: [{
            name: 'Truck Count',
            data: chartData.map(item => ({
                name: item.other_oem_geofence,
                y: item.count,
                other_oem_geofence: item.other_oem_geofence,
                plant_name: item.plant_name // ✅ this is correct
            })),
            showInLegend: false
        }],
        responsive: {
            rules: [{
                condition: { maxWidth: 500 },
                chartOptions: {
                    xAxis: { labels: { rotation: -90 } },
                    plotOptions: { column: { dataLabels: { inside: true } } }
                }
            }]
        }
    };
    const handleCellClick = (point) => {
        try {
            const payload = {
                consignee_area: point.name.split(' - ')[0],
                plant_name: point.plant_name, // ✅ correct key
                other_oem_geofence: point.other_oem_geofence,
                defaultTitle: "Other OEM Geofence"
            };
            if (selectedPlant && selectedPlant.value.toLocaleLowerCase() != 'all') {
                payload.selected_plant = selectedPlant.value
            }
            if (selectedCity && selectedCity.value.toLocaleLowerCase() != 'all') {
                payload.selected_city = selectedCity.value
            }
            onClickedOnReturnTripCity(payload)
        } catch (e) {
            console.log("Error", e)
        }
    };
    return (
        <div style={{ padding: '20px' }}>
            {/* Filters with Premium UI */}
            <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'center' }}>
                <div style={{ minWidth: 200 }}>
                    <label><strong>Dealer Area:</strong></label>
                    <Select
                        options={cityOptions}
                        value={selectedCity}
                        onChange={value => setSelectedCity(value || allOption)}
                        // isClearable
                        placeholder="Select City"
                        isMulti={false}
                        closeMenuOnSelect={true}
                    />
                </div>
                <div style={{ minWidth: 200 }}>
                    <label><strong>Return Plant</strong></label>
                    <Select
                        options={plantOptions}
                        value={selectedPlant}
                        onChange={value => setSelectedPlant(value || allOption)}
                        // isClearable
                        placeholder="Select Plant"
                        isMulti={false}
                        closeMenuOnSelect={true}
                    />
                </div>
            </div>
            {/* Chart */}
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        </div>
    );
};
const ConsigneeAreaStackedChart = ({ data, onClickedOnCityWiseCount }) => {
    const allOption = { value: 'All', label: 'All' };
    const ITEMS_PER_PAGE = 10;
    const [currentPage, setCurrentPage] = useState(0);
    const [selectedCity, setSelectedCity] = useState(allOption);
    const [selectedPlant, setSelectedPlant] = useState(allOption);
    const [selectedDealerCity, setSelectedDealerCity] = useState(allOption);
    const [selectedDealerArea, setSelectedDealerArea] = useState(allOption);
    const selectedCityRef = useRef(allOption);
    const selectedPlantRef = useRef(allOption);
    const selectedDealerCityRef = useRef(allOption);
    const selectedDealerAreaRef = useRef(allOption);
    // Update refs when relevant selections change
    useEffect(() => {
        selectedCityRef.current = selectedCity;
    }, [selectedCity]);
    useEffect(() => {
        selectedPlantRef.current = selectedPlant;
    }, [selectedPlant]);
    useEffect(() => {
        setCurrentPage(0);
    }, [selectedCity, selectedPlant]);
    // Data preparation
    const uniqueCities = [...new Set(data.map(d => d.consignee_area).filter(Boolean))];
    const uniquePlants = [...new Set(data.map(d => d.return_plant_name).filter(Boolean))];
    const cityOptions = [allOption, ...uniqueCities.map(city => ({ value: city, label: city }))];
    const plantOptions = [allOption, ...uniquePlants.map(plant => ({ value: plant, label: plant }))];
    // Dealer Area & Dealer City Options
    const uniqueDealerAreas = [...new Set(data.map(d => d.consignee_area).filter(Boolean))];
    const dealerAreaOptions = [allOption, ...uniqueDealerAreas.map(area => ({ value: area, label: area }))];
    const filteredCities = selectedDealerArea.value === 'All'
        ? []
        : data
            .filter(d => d.consignee_area === selectedDealerArea.value)
            .map(d => d.consignee_city)
            .filter(Boolean);
    const uniqueFilteredCities = [...new Set(filteredCities)];
    const dealerCityOptions = [allOption, ...uniqueFilteredCities.map(city => ({ value: city, label: city }))];
    // Apply filters
    const filteredData = data.filter(item => {
        const areaMatch = selectedDealerArea.value === 'All' || item.consignee_area === selectedDealerArea.value;
        const cityMatch = selectedDealerCity.value === 'All' || item.consignee_city === selectedDealerCity.value;
        const plantMatch = selectedPlant.value === 'All' || item.return_plant_name === selectedPlant.value;
        return areaMatch && cityMatch && plantMatch;
    });
    const grouped = {};
    for (const item of filteredData) {
        const area = item.consignee_area || 'Unknown';
        const isLoad = item.other_oem_load === 1;
        if (!grouped[area]) {
            grouped[area] = { load: 0, noload: 0, plant_name: item.return_plant_name };
        }
        if (isLoad) {
            grouped[area].load += 1;
        } else {
            grouped[area].noload += 1;
        }
    }
    const sortedEntries = Object.entries(grouped).sort(([, a], [, b]) => {
        const aTotal = a.load + a.noload || 1;
        const bTotal = b.load + b.noload || 1;
        const aPercentage = (a.load / aTotal) * 100;
        const bPercentage = (b.load / bTotal) * 100;
        return bPercentage - aPercentage;
    });
    const totalPages = Math.ceil(sortedEntries.length / ITEMS_PER_PAGE);
    const paginatedEntries = sortedEntries.slice(
        currentPage * ITEMS_PER_PAGE,
        (currentPage + 1) * ITEMS_PER_PAGE
    );
    const categories = paginatedEntries.map(([area]) => area);
    const truckData = paginatedEntries.map(([, data]) => {
        const total = data.load + data.noload || 1;
        return {
            load: {
                y: (data.load / total) * 100,
                percentage: (data.load / total) * 100,
                count: data.load
            },
            noload: {
                y: (data.noload / total) * 100,
                percentage: (data.noload / total) * 100,
                count: data.noload
            }
        };
    });
    const isDealerCitySelected = selectedDealerCity.value !== 'All';
    const chartOptions = {
        chart: {
            type: 'column',
            height: 500
        },
        title: {
            text: isDealerCitySelected
                ? 'Dealer City: Load vs Empty Return Trips (%)'
                : 'Dealer Area: Load vs Empty Return Trips (%)',
            align: 'left'
        },
        xAxis: {
            categories,
            title: { text: isDealerCitySelected ? 'Dealer City' : 'Dealer Area' },
            crosshair: true,
            labels: { rotation: -45, style: { fontSize: '12px' } }
        },
        yAxis: {
            min: 0,
            max: 100,
            title: { text: 'Percentage of Trips (%)' },
            labels: { format: '{value}%', style: { fontSize: '12px' } }
        },
        tooltip: {
            formatter: function () {
                var percentage = this.point.percentage ? this.point.percentage.toFixed(1) : '0.0';
                var count = typeof this.point.count === 'number' ? this.point.count : 0;
                return (
                    '<b>' + this.x + '</b><br/>' +
                    this.series.name + '<br/>' +
                    'Count: <b>' + count + '</b> trips<br/>' +
                    'Percentage: <b>' + percentage + '%</b>'
                );
            }
        },
        plotOptions: {
            column: {
                stacking: null,
                pointPadding: 0.2,
                groupPadding: 0.15,
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    formatter: function () {
                        return this.point.percentage ? this.point.percentage.toFixed(1) + '%' : '';
                    },
                    style: {
                        color: '#000',
                        fontSize: '12px',
                        textOutline: 'none'
                    }
                },
                point: {
                    events: {
                        click: function () {
                            const type = this.series.name === 'Trips with Load' ? 'load' : 'noload';
                            const payload = {
                                consignee_area: this.category,
                                truck_type: type,
                                defaultTitle: 'Dealer City'
                            };
                            const plantValue = selectedPlantRef.current.value;
                            const cityValue = selectedCityRef.current.value;
                            const dealerAreaValue = selectedDealerAreaRef.current.value;
                            const dealerCityValue = selectedDealerCityRef.current.value;
                            if (plantValue !== 'All') payload.plant_name = plantValue;
                            if (cityValue !== 'All') payload.selected_city = cityValue;
                            if (dealerAreaValue !== 'All') payload.selected_area = dealerAreaValue;
                            if (dealerCityValue !== 'All') payload.selected_city = dealerCityValue;
                            onClickedOnCityWiseCount(payload);
                        }
                    }
                }
            }
        },
        series: [
            {
                name: 'Trips with Load',
                color: '#2482D1',
                data: truckData.map(d => ({
                    y: d.load.percentage,
                    percentage: d.load.percentage,
                    count: d.load.count
                }))
            },
            {
                name: 'Empty Return Trips',
                color: '#6eb7f5',
                data: truckData.map(d => ({
                    y: d.noload.percentage,
                    percentage: d.noload.percentage,
                    count: d.noload.count
                }))
            }
        ],
        legend: {
            align: 'right',
            verticalAlign: 'top',
            layout: 'vertical'
        }
    };
    return (
        <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
                <div style={{ minWidth: 200 }}>
                    <label><strong>Dealer Area:</strong></label>
                    <Select
                        options={dealerAreaOptions}
                        value={selectedDealerArea}
                        onChange={value => {
                            const updated = value || allOption;
                            setSelectedDealerArea(updated);
                            selectedDealerAreaRef.current = updated;
                            setSelectedDealerCity(allOption);
                            selectedDealerCityRef.current = allOption;
                        }}
                        placeholder="Select Dealer Area"
                        isMulti={false}
                        closeMenuOnSelect
                    />
                </div>
                {selectedDealerArea.value !== 'All' && (
                    <div style={{ minWidth: 200 }}>
                        <label><strong>Dealer City:</strong></label>
                        <Select
                            options={dealerCityOptions}
                            value={selectedDealerCity}
                            onChange={value => {
                                const updated = value || allOption;
                                setSelectedDealerCity(updated);
                                selectedDealerCityRef.current = updated;
                            }}
                            placeholder="Select Dealer City"
                            isMulti={false}
                            closeMenuOnSelect
                        />
                    </div>
                )}
            </div>
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
            {/* Pagination */}
            <div style={{ margin: '10px 0' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '20px' }}>

                    <div>
                        Showing <strong>{paginatedEntries.length}</strong> of <strong>{sortedEntries.length}</strong> Dealer Cities
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <button
                            onClick={() => setCurrentPage(0)}
                            disabled={currentPage === 0}
                            className="pagination-btn"
                        >
                            ⏮ First
                        </button>
                        <button
                            onClick={() => setCurrentPage(prev => prev - 1)}
                            disabled={currentPage === 0}
                            className="pagination-btn"
                        >
                            ⬅ Prev
                        </button>
                        {Array.from({ length: totalPages }, (_, i) => (
                            <button
                                key={i}
                                onClick={() => setCurrentPage(i)}
                                className={`pagination-btn ${i === currentPage ? 'active' : ''}`}
                                style={{
                                    padding: '5px 10px',
                                    border: '1px solid #ddd',
                                    backgroundColor: i === currentPage ? '#2482D1' : 'white',
                                    color: i === currentPage ? 'white' : 'black',


                                    cursor: 'pointer'
                                }}
                            >
                                {i + 1}
                            </button>
                        ))}
                        <button
                            onClick={() => setCurrentPage(prev => prev + 1)}
                            disabled={currentPage === totalPages - 1}
                            className="pagination-btn"
                        >
                            Next ➡
                        </button>
                        <button
                            onClick={() => setCurrentPage(totalPages - 1)}
                            disabled={currentPage === totalPages - 1}
                            className="pagination-btn"
                        >
                            Last ⏭
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
